export const LOADING_GET_ADMIN_EMAILS = 'LOADING_GET_ADMIN_EMAILS';
export const LOADING_GET_ADMIN_EMAILS_ERROR = 'LOADING_GET_ADMIN_EMAILS_ERROR';
export const LOADING_GET_ADMIN_EMAILS_SUCCESS = 'LOADING_GET_ADMIN_EMAILS_SUCCESS';
